export default {
  colors: [
    { value: 'black', text: 'Preto' },
    { value: 'blue', text: 'Azul' },
    { value: 'cyan', text: 'Ciano' },
    { value: 'green', text: 'Verde' },
    { value: 'orange', text: 'Laranja' },
    { value: 'pink', text: 'Rosa' },
    { value: 'purple', text: 'Roxo' },
    { value: 'red', text: 'Vermelho' },
    { value: 'silver', text: 'Prata' },
    { value: 'yellow', text: 'Amarelo' },
  ],
  styles: [
    { value: '01', text: '01' },
    { value: '02', text: '02' },
    { value: '03', text: '03' },
    { value: '04', text: '04' },
    { value: '05', text: '05' },
    { value: '06', text: '06' },
    { value: '07', text: '07' },
    { value: '08', text: '08' },
    { value: '09', text: '09' },
    { value: '10', text: '10' },
    { value: '11', text: '11' },
    { value: '12', text: '12' },
    { value: '13', text: '13' }   
  ]
}